import React, { useEffect, useState } from "react";
import {
  CompanyManageMyCompany,
  CompanyManageMyStoreMyStoreCompany,
  PriceGetGroupPrice,
  PriceHistoryPrice,
} from "../../Api/Services";
import imgPlus from "../../assets/Icon/pluse.png";
import { useNavigate } from "react-router-dom";
import imgDoc from "../../assets/Icon/icons8-edit-48.png";

function Prices() {
  const [Data, setData] = useState();
  const [MyStore, setMyStore] = useState();
  const [isLoading, setLoading] = useState(true);
  const [Company, setCompany] = useState();
  const [ActiveItem, setActiveItem] = useState({});
  const [PricesDate, setPricesDate] = useState([]);

  const navigate = useNavigate();

  const jalaali = require("jalaali-js");

  const start = async () => {
    setCompany([]);
    try {
      const CompanyManageMyCompanysData = await CompanyManageMyCompany();
      if (
        CompanyManageMyCompanysData.status &&
        CompanyManageMyCompanysData.status === 200
      ) {
        setCompany(CompanyManageMyCompanysData.data.data);
        const PriceGetGroupPriceData = await PriceGetGroupPrice();
        if (
          PriceGetGroupPriceData.status &&
          PriceGetGroupPriceData.status === 200
        ) {
          setPricesDate(PriceGetGroupPriceData.data.data.data);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const SetCompany = async (id, date) => {
    setLoading(true);
    try {
      const PriceHistoryPriceData = await PriceHistoryPrice({
        Id: id,
        Date: date,
      });
      if (
        PriceHistoryPriceData.status &&
        PriceHistoryPriceData.status === 200
      ) {
        setData(PriceHistoryPriceData.data.data.data);

        const CompanyManageMyStoreMyStoreCompanyData =
          await CompanyManageMyStoreMyStoreCompany(id);
        if (
          CompanyManageMyStoreMyStoreCompanyData.status &&
          CompanyManageMyStoreMyStoreCompanyData.status === 200
        ) {
          setMyStore(CompanyManageMyStoreMyStoreCompanyData.data.data);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
      setActiveItem({ Id: id, Date: date });
    }
  };

  useEffect(() => {
    start();
  }, []);

  const Add = () => {
    navigate("/Panel/PricesAE/0");
  };

  const Edite = (extra) => {
    navigate("/Panel/PricesAE/" + extra);
  };

  const groupProducts = (products) => {
    const groups = {};
    products.forEach((p) => {
      const key = [
        p.productBerandId,
        p.productTypeId,
        p.productSeriesId,
        p.symbol,
        p.productSeriesEndId,
        p.productRamId,
        p.productRomId,
        p.productNetworkId,
        p.productCountryId,
        p.isInsurance,
      ].join("-");
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(p);
    });
    return Object.values(groups);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex justify-content-start align-items-center w-100 mb-5 pointer">
            <img
              onClick={() => {
                Add();
              }}
              src={imgPlus}
              alt=""
            />
          </div>
          <div className="d-flex justify-content-center align-item-center w-100 flex-column">
            {PricesDate &&
              PricesDate.map((itemDate) => (
                <>
                  <div
                    className={`d-flex justify-content-between align-items-center w-100 mt-3 p-3  border border-2 border-black ${
                      ActiveItem.Date == itemDate
                        ? "bg-warning"
                        : "bg-body-secondary"
                    }`}
                  >
                    {ActiveItem.date}
                    <img
                      className="pointer"
                      height="30"
                      src={imgDoc}
                      alt="ویرایش"
                      onClick={() => {
                        Edite(itemDate);
                      }}
                    />
                    <h5>
                      {(() => {
                        const date = new Date(itemDate.replace("T", " "));
                        const jalaaliDate = jalaali.toJalaali(date);
                        const year = jalaaliDate.jy;
                        const month = jalaaliDate.jm
                          .toString()
                          .padStart(2, "0");
                        const day = jalaaliDate.jd.toString().padStart(2, "0");
                        const hours = date
                          .getHours()
                          .toString()
                          .padStart(2, "0");
                        const minutes = date
                          .getMinutes()
                          .toString()
                          .padStart(2, "0");
                        const seconds = date
                          .getSeconds()
                          .toString()
                          .padStart(2, "0");

                        return `${hours}:${minutes}:${seconds} ${year}/${month}/${day}`;
                      })()}
                    </h5>
                    <div className="d-flex justify-content-between align-items-center">
                      {Company &&
                        Company.map((item, key) => (
                          <button
                            onClick={() => {
                              SetCompany(item.companyId, itemDate);
                            }}
                            className={`m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2 ${
                              ActiveItem.Id == item.companyId &&
                              ActiveItem.Date == itemDate
                                ? "bg-success"
                                : ""
                            }`}
                          >
                            {item.companyName}
                          </button>
                        ))}
                    </div>
                  </div>

                  {Data && itemDate == ActiveItem.Date && (
                    <div className="d-flex justify-content-center align-items-center w-100 tableC">
                      <table
                        className="table tableMore"
                        style={{ lineHeight: "normal" }}
                      >
                        <thead className="sticky-header">
                          <tr className="trTable">
                            <th>سیمبل کالای</th>
                            <th>رنگ</th>
                            <th>انبار</th>
                            <th>قیمت</th>
                          </tr>
                        </thead>

                        {Data.filter((w) => w.companyStorePrices.length > 0) &&
                          groupProducts(
                            Data.filter((w) => w.companyStorePrices.length > 0),
                          ).map((group, gIndex) => (
                            <tbody
                              key={gIndex}
                              style={{
                                backgroundColor:
                                  gIndex % 2 === 0 ? "#ffffff" : "#e6f0ff",
                              }}
                            >
                              {group.map((itemPro, iIndex) => {
                                return (
                                  <>
                                    {MyStore.map((store, sIndex) => (
                                      <tr
                                        key={`${itemPro.id}-${store.companyStoreId}`}
                                      >
                                        {iIndex === 0 && sIndex === 0 && (
                                          <td
                                            rowSpan={
                                              group.length * MyStore.length
                                            }
                                          >
                                            {itemPro.productBerandName != " " &&
                                              itemPro.productBerandName + " "}
                                            {itemPro.productTypeName != " " &&
                                              itemPro.productTypeName + " "}
                                            {itemPro.productSeriesName != " " &&
                                              itemPro.productSeriesName}
                                            {itemPro.symbol}
                                            {itemPro.productSeriesEndName != " "
                                              ? itemPro.productSeriesEndName +
                                                " "
                                              : " "}
                                            {itemPro.productRamName != " " &&
                                              itemPro.productRamName + "/"}
                                            {itemPro.productRomName != " " &&
                                              itemPro.productRomName + " "}
                                            {itemPro.productNetworkName !=
                                              " " &&
                                              itemPro.productNetworkName + " "}
                                            {itemPro.productCountryName !=
                                              " " &&
                                              itemPro.productCountryName + " "}
                                            {itemPro.isInsurance && "بیمه"}
                                          </td>
                                        )}
                                        {sIndex === 0 && (
                                          <td rowSpan={MyStore.length}>
                                            {itemPro.productColorName}
                                          </td>
                                        )}
                                        <td>{store.companyStoreName}</td>
                                        <td>
                                          {itemPro.companyStorePrices
                                            .find(
                                              (w) =>
                                                w.companyStoreId ===
                                                store.companyStoreId,
                                            )
                                            ?.price?.toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ",",
                                            ) || "-"}
                                        </td>
                                      </tr>
                                    ))}
                                  </>
                                );
                              })}
                            </tbody>
                          ))}
                      </table>
                    </div>
                  )}
                </>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Prices;
